import React from 'react';

const { PageLevelMessage } = require('@americanexpress/dls-react');

interface MessageBannerProps {
  type?: string,
  messageText: string,
  showMessage?: boolean,
  classes?: string,
}

const MessageBanner: React.FC<MessageBannerProps> = (props) => {
  const { showMessage } = props;
  const classes = props.classes || 'col-md-4 col-md-offset-4';
  return (
    <div>
      {showMessage
        && (
          <div className="row pad-1-t">
            <div className={classes}>
              <PageLevelMessage type={props.type} show="true" dismissible="false" filled="false">{props.messageText}
              </PageLevelMessage>
            </div>
          </div>
        )}
    </div>

  );
};

export default MessageBanner;
